import { ALLERGENS, type AllergenKey } from '../data/allergens';

export function normalizeAllergenText(s: string): string {
  return s
    .replace(/[œŒ]/g, 'oe')
    .replace(/[æÆ]/g, 'ae')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/['']/g, ' ');
}

export function buildAllergenTerms(keys: AllergenKey[], custom: string[]): string[] {
  const terms: string[] = [];

  // Add terms from allergen families
  for (const key of keys) {
    const def = ALLERGENS[key];
    if (def) {
      terms.push(...def.terms);
    }
  }

  // Add normalized custom entries
  for (const entry of custom) {
    terms.push(normalizeAllergenText(entry));
  }

  return terms;
}

export function recipeHasAllergen(
  recipe: { title: string; ingredients: string[] },
  terms: string[],
): boolean {
  if (terms.length === 0) {
    return false;
  }

  // Build the haystack: title + space + joined ingredients
  const haystack = normalizeAllergenText(recipe.title + ' ' + recipe.ingredients.join(' '));

  // Check each term with word-anchored matching and plural tolerance
  for (const term of terms) {
    // Escape regex special characters in the term
    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    // Word-anchored pattern with plural tolerance (s, x, es)
    const pattern = new RegExp(`(^|[^a-z0-9])${escapedTerm}(s|x|es)?([^a-z0-9]|$)`);

    if (pattern.test(haystack)) {
      return true;
    }
  }

  return false;
}
